<template>
    <!-- 暂时没有用到 -->
    <!-- vue 模板未改造完成 -->
    <!-- <div v-if="false"
        class="carsItem carItem #if({{ data.userDefinedStatus }}=='ALREADY_RESERVED') already_reserved #end"
        data-id="{{ data.id }}">
        <a href="/car/{{ data.id }}"
            target="_blank"
            class="carImg">
            <img
                src="//res.souche.com/images/fed/zhanwei.png" data-original="$carImgUrlUtil.formatUrl({{ data.bigImage }},279,186)$!{widgetUtil.getWaterMark({{ data.bigImage }},'%7C',279,13)}"
                alt="{{ data.fullName }}"
                width="325px"
                style="display: inline; width: 100%; height: auto;">
            <div class="timebuy hidden"></div>
        </a>
        <a href="/car/{{ data.id }}"
            target="_blank"
            class="car-link">$!item.fullName </a>
        <div class="car-price">
            <span class="price">
            #if($!item.consignment!=1)
                <span class="price-amount">$!item.price</span> #else
                <span class="price-amount">首付$!item.prepaidLeaseAmount万</span> #*
                <span class="price-amount">月供$!item.installmentPayment元</span>*#
                <img src="//img.souche.com/20161213/png/e4ca1def296c54355b13e761b29da194.png" width="65px" style="display: inline;" /> #end
            </span>
        </div>
        <div class="car-info">
            <span class="info-item">$!item.year</span>
            <em>|</em>
            <span class="info-item">$!item.mileage万公里</span>
            <em>|</em>
            <span class="info-item">
                <span class="info-item-name">归属地:</span>
                $!item.cityName
            </span>
        </div>
        <div class="carTail clearfix">
            <a data-carid="{{ data.id }}"
                data-shopid="{{ data.shopId }}"
                click_type="sale-favs"
                data-num="{{ data.collectCount }}"
                title="收藏 {{ data.collectCount }}"
                class="fav collect #if({{ data.collected }})colled#end">
                <span class="add-to-coll">收藏</span>
                <span class="already-colled">已收藏</span>
                <span class="fav-count" data-favcount="{{ data.collectCount }}">{{ data.collectCount }}</span>
            </a>
        </div>
    </div> -->
</template>
<script>
export default {
    props: ['data']
};
</script>
<style lang="less" scoped>
/** 这里占位，车辆组件样式不需要全局使用时，迁移到这里 */
</style>
<style lang="less">
/** 这里用于提高优先级 */
.card-box.card-box .carItem {
    width: 238px;
    height: 275px;
    overflow: hidden;
    border: 1px solid #E6E6E6;
    float: left;
    margin-left: 20px;
    position: relative;
    margin-bottom: 20px;
    background: #fff;
    .carImg {
        display: block;
        position: relative;
        width: 240px;
        height: 160px;
        margin: -1px 0 0 -1px;
        overflow: hidden;
        img {
            width: 100%;
            height: auto;
            border: none;
        }
    }
    .car-Link {
        font-size: 14px;
        color: #333;
        display: block;
        height: 40px;
        margin: 10px 15px 0 15px;
        overflow: hidden;
    }
    .car-price {
        margin: 5px 15px;
        .price {
            color: #ff5517;
            font-weight: bold;
            margin-right: 5px;
        }
        .price-amount {
            font-family: 'Tahoma';
            font-weight: bold;
            font-size: 16px;
        }
        .tangeche-logo {
            height: 16px;
            position: absolute;
            bottom: 43px;
            right: 16px;
            img {
                // height: 16px;
            }
        }
    }
    .car-info {
        margin: 0 15px;
        color: #999;
        font-size: 12px;
        margin-bottom: 20px;
        span,
        em {
            margin-left: 2px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// CarItemForGrid.vue?46645f3f